import { observer } from 'mobx-react-lite'
import { type ScopeChangeInventoryItemViewModel } from '@/features/jobs/details/components/RequestScopeChangesDialog/ListItems/ScopeChangeInventoryItem/ScopeChangeInventoryItemViewModel'
import {
  ScopeChangeInventoryItemSelection,
  ScopeChangeInventoryItemUpdateQuantity,
} from '@/features/jobs/details/components/RequestScopeChangesDialog/ListItems/ScopeChangeInventoryItem'

export interface ScopeChangeInventoryItemContainerProps {
  vm: ScopeChangeInventoryItemViewModel
  updateQuantity?: boolean
}

export const ScopeChangeInventoryItemContainer = observer(
  function ScopeChangeInventoryItemContainer({
    vm,
    updateQuantity,
  }: ScopeChangeInventoryItemContainerProps) {
    if (updateQuantity) {
      return (
        <ScopeChangeInventoryItemUpdateQuantity
          name={vm.name}
          description={vm.description}
          currentQuantity={vm.currentQuantity}
          newQuantity={vm.newQuantity}
          hasQuantityError={!!vm.validation.getError('newQuantity')}
          onRemove={vm.toggle}
          onQuantityChange={vm.setQuantity}
          removeButtonTestId={`request-scope-changes-inventory-remove-button-${vm.name}`}
          quantityInputTestId={`scope-change-inventory-quantity-${vm.name}`}
        />
      )
    }

    return (
      <ScopeChangeInventoryItemSelection
        name={vm.name}
        description={vm.description}
        selected={vm.selected}
        onToggle={vm.toggle}
        testId={`scope-change-inventory-item-${vm.name}`}
      />
    )
  },
)
